import gql from 'graphql-tag';

export const VALIDATE_SCHOOL_PROPOSAL = gql`
  mutation Mutation($input: validateSchoolProposal!) {
    validateSchoolProposal(input: $input)
  }
`;
